import makeStyles from '@mui/styles/makeStyles'

export const useDialogStyles = makeStyles((theme) => ({
  paper: {
    margin: 0,
  },
  paperFullWidth: {
    width: '100%',
  },
  paperScrollPaper: {
    [theme.breakpoints.down('md')]: {
      maxHeight: '100%',
    },
  },
}))
